import { StyleSheet } from 'aphrodite';
export const styles = StyleSheet.create({
    page: {
        width: "95vw",
        display: "grid",
        paddingLeft: '10px',
        paddingRight: "10px",
        gridTemplateRows: "min-content min-content auto"
    },

    searchTerm: {
        marginTop: "20px",
        marginBottom: "20px",
        fontSize: "25px"    
    },

    card : {
        backgroundColor: "#fff",
        borderRadius: 5,
        boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        marginTop: "20px"
    },

    resultsList: {
        overflowY: "hidden",
        ":hover": {
            overflowY : "auto"
        }
    },

    resultListItemTitle: {
        fontWeight: "bold",
        color: "#4286f4",
        ":hover": {
            textDecoration: "underline",
            cursor: "pointer"
        }
    },
    participantsContainer: {
        display: "inline",
    },
    participant: {
        display: "inline-block",
        fontSize: "16px"
    },
    
})


// WEBPACK FOOTER //
// ./src/pages/SearchListPageStyle.ts